<template>
  <!-- 需要软件升级弹窗 -->
  <div>
    <el-dialog
        :append-to-body="true"
        title="需要软件升级"
        :visible.sync="dialogVisible"
        width="524px"
        :before-close="handleClose"
        class="upSoftDialog"
        >
        <div>
          <div>您的版本过低，无法使用该功能，建议升级为<span :style="{'color':changeColor}">【高级版】</span></div>
          <div>解锁更多高效转化功能！</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <!-- <el-button class="cancel_Btn" @click="cancelBtn">取消</el-button> -->
            <el-button class="sure_Btn" type="primary" @click="sureBtn">去升级>></el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTaobaoItemList
} from "@/api/public";
import Pagination from "./pagination";
import { mapState, mapMutations, mapActions } from "vuex";
import { getBuyerLabelByLabelName} from "../api/buyerLabelController";
export default {
  name: "select-goods",
  components: { Pagination },
  props: {
    labelState: {
      type: false,
      default: 0
    },
  },
  data() {
    return {
      dialogVisible: true,
      jumpUrl: 'https://fuwu.taobao.com/ser/detail.htm?spm=a1z13.8114210.1234-fwlb.4.36e25acaDENSPP&service_code=ts-131195&tracelog=search&from_key=%E4%BA%91%E7%9F%AD%E4%BF%A1',
    };
  },
  computed: {
    ...mapState({
      changeColor: "globalBG",
    }),
  },
  beforeCreate() {},
  beforeMount() {},
  created() {

  },
  mounted() {
      // this.dialogVisible = this.labelState;
  },
  methods: {
    cancelBtn(){
        this.dialogVisible = false;
        this.$emit("transferName5");
    },
    handleClose(done) {
        this.cancelBtn();
    },
    sureBtn(){
        this.dialogVisible = false;
        this.$emit("transferName5");
        window.open(this.jumpUrl, '_blank');
    },



  }
};
</script>

<style lang="scss" scoped>
.left-small-item {
    display: inline-block;
    // width: 110px;
    height: 28px;
    // border: 1px solid rgba(239, 239, 239, 1);
    border: 1px solid #DCDCDC;
    opacity: 1;
    border-radius: 2px;
    margin-right: 2px;
    margin-bottom: 16px;
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: rgba(102,102,102,1);
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border-radius: 8px;
    padding: 0px 10px;
    margin-right: 16px;
    border-radius: 2px;
    p {
      margin: 0;
      padding: 0;
    }
    .right-gou {
      position: absolute;
      bottom: -1px;
      right: 0;
    }
}


</style>
<style lang="scss">
    .upSoftDialog{
      z-index: 5001!important;
    }
    .upSoftDialog .el-dialog{
        // height: 450px;
        margin-top: 25vh!important;
        .el-dialog__body{
            // height: 330px;
            overflow: auto;
            background: #fff;
            font-size: 16px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(51,51,51,1);
            line-height: 28px;
            text-align: center;
            padding: 20px;
        }
        .el-dialog__footer{
            padding-top: 0px;
            text-align: center;
            .cancel_Btn{
                width: 96px;
                height: 36px;
                border-radius: 6px;
                border: 1px solid rgba(153,153,153,1);
                font-size: 16px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                color: rgba(102,102,102,1);
            }
            .sure_Btn{
                width: 96px;
                height: 36px;
                // background: rgba(32,98,231,1);
                border-radius: 6px;
                // font-size: 16px;
                font-family: PingFangSC-Regular;
                font-weight: 400;
                // color: rgba(255,255,255,1);
                font-size: 14px;
            }

        }
    }

</style>
